<template>
  <div :class="$style.orderInfoItem">
    <div :class="$style.orderInfoLabel">
      <div :class="$style.orderInfoImage">
        <svg v-svg
             :class="$style.orderInfoIcon"
             :symbol="data.icon"/>
      </div>
      <h6>{{ data.title }}</h6>
    </div>
    <p :class="$style.orderInfoData">{{ data.value }}</p>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

  @Component({
    name:  'OrderField',
    props: {
      data: {},
    },
  })
export default class OrderField extends Vue {}
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";
  $order-item-border: #C4C4C4;

  .orderInfoItem {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $order-item-border;
    padding: 20px 0;
    &:last-child {
      border-bottom: none;
    }
  }

  .orderInfoLabel {
    display: flex;
    align-items: center;
    h6 {
      margin-left: 16px;
    }
  }

  .orderInfoIcon {
    width: 20px;
    height: 20px;
  }

  .orderInfoData {
    padding-right: 12px;
    white-space: pre;
  }

  @media screen and (max-width: 767px) {
    .orderInfoItem {
      border: none;
      justify-content: center;
      align-items: flex-start;
      padding: 10px 0;
    }

    .orderInfoLabel h6 {
      display: none;
    }

    .orderInfoData {
      color: $white;
      margin-left: 10px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/OrderField.vue